import React, { useState, useRef } from 'react';
import config from '../config';
import '../styles/FAQ.css';

function FAQ() {
  const [openId, setOpenId] = useState(null);
  const answerRefs = useRef({});

  const toggleItem = (id) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section id="faq" className="faq-section">
      <div className="sec-head reveal">
        <h2>FAQ</h2>
      </div>
      <div className="faq-wrap reveal">
        {config.faq.map((item) => (
          <div 
            key={item.id} 
            className={`faq-item ${openId === item.id ? 'open' : ''}`}
            id={`faq${item.id}`}
          >
            <button 
              className="faq-q" 
              type="button"
              aria-expanded={openId === item.id}
              aria-controls={`faq-answer-${item.id}`}
              onClick={() => toggleItem(item.id)}
            >
              {item.question}
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                <path d="m6 9 6 6 6-6" />
              </svg>
            </button>
            <div 
              className="faq-a" 
              id={`faq-answer-${item.id}`}
              aria-hidden={openId !== item.id}
              ref={el => answerRefs.current[item.id] = el}
              style={{
                maxHeight: openId === item.id 
                  ? `${answerRefs.current[item.id]?.scrollHeight || 200}px` 
                  : '0'
              }}
            >
              <p>{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default FAQ;
